<ng-container *ngIf="isMobile">

    <!-- Floating Action Button: idle / connecting / minimized -->
    <div
      class="fab-wrap"
      [class.state-live]="state === 'minimized'"
      *ngIf="state === 'closed' || state === 'connecting' || state === 'minimized'"
    >
      <div class="fab-ring" *ngIf="state !== 'minimized'"></div>
      <div class="fab-live-arc" *ngIf="state === 'minimized'"></div>
  
      <button
        class="fab"
        [class.is-connecting]="state === 'connecting'"
        (click)="openAssistant()"
        [attr.aria-label]="state === 'minimized' ? 'Resume conversation with Trinka AI' : 'Talk to Trinka AI'"
      >
        <span class="sparkle" *ngIf="state !== 'connecting'">
          <svg viewBox="0 0 24 24"><path d="M12 2l1.8 5.6L19 9l-5.2 1.6L12 16l-1.8-5.4L5 9l5.2-1.4L12 2z"/></svg>
        </span>

        <svg  *ngIf="state !== 'connecting'" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.3426 22.6573C25.5409 22.2373 25.6343 21.8057 25.6343 21.3857C25.6343 21.059 25.5643 20.7673 25.4476 20.4757C25.3193 20.184 25.1093 19.939 24.8059 19.729L20.9443 16.9873C20.6526 16.789 20.3843 16.6373 20.1276 16.5323C19.8709 16.4273 19.6376 16.3807 19.4159 16.3807C19.1243 16.3807 18.8559 16.4623 18.5876 16.6257C18.3193 16.7657 18.0393 16.9873 17.7476 17.279L16.8609 18.154C16.7326 18.2823 16.5809 18.3523 16.3826 18.3523C16.2776 18.3523 16.1843 18.3407 16.0909 18.3057C16.0093 18.2707 15.9393 18.2357 15.8809 18.2123C15.4843 18.0023 14.9826 17.6523 14.3759 17.139C13.7576 16.614 13.1509 16.0423 12.5209 15.424C11.9143 14.8057 11.3543 14.1873 10.8293 13.5807C10.3159 12.974 9.95427 12.4723 9.74427 12.0873C9.72094 12.0173 9.68594 11.9473 9.65094 11.854C9.6276 11.7607 9.61594 11.679 9.61594 11.5857C9.61594 11.399 9.67427 11.2473 9.8026 11.119L10.6893 10.1973C10.9693 9.91732 11.1909 9.63732 11.3426 9.36898C11.5059 9.10065 11.5876 8.82065 11.5876 8.54065C11.5876 8.31898 11.5293 8.07398 11.4243 7.82898C11.3193 7.57232 11.1676 7.30399 10.9576 7.01232L8.25094 3.19732C8.04094 2.89398 7.7726 2.68398 7.46927 2.54398C7.1776 2.40398 6.85094 2.33398 6.52427 2.33398C5.66094 2.33398 4.84427 2.69565 4.0976 3.43065C3.47927 4.01398 3.03594 4.66732 2.75594 5.37898C2.47594 6.07898 2.33594 6.83732 2.33594 7.63065C2.33594 8.84398 2.61594 10.1157 3.17594 11.4457C3.73594 12.764 4.50594 14.094 5.4626 15.424C6.44967 16.7761 7.53779 18.0514 8.7176 19.239C9.91032 20.4213 11.1894 21.5132 12.5443 22.5057C13.8743 23.474 15.2159 24.244 16.5576 24.8157C17.8993 25.3873 19.1709 25.6673 20.3609 25.6673C21.1776 25.6673 21.9359 25.5157 22.6359 25.224C23.3476 24.9323 23.9776 24.4773 24.5493 23.8473C24.8876 23.474 25.1443 23.0773 25.3426 22.6573Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
  
        <svg *ngIf="state === 'connecting'" class="spinner" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-dasharray="42 100"/>
        </svg>
      </button>
    </div>
  
    <!-- Scrim -->
    <div
      class="sheet-scrim"
      [class.open]="state === 'idle' || state === 'listening' || state === 'thinking' || state === 'speaking'"
      (click)="minimize()"
    ></div>
  
    <!-- Bottom sheet -->
    <div
      class="sheet"
      [class.open]="state === 'idle' || state === 'listening' || state === 'thinking' || state === 'speaking'"
      [ngClass]="'state-' + state"
    >
      <div class="sheet-handle"></div>
  
      <div class="sheet-header">
        <div class="brand">
          <div class="logo-badge">
            <svg viewBox="0 0 24 24" fill="none"><path d="M12 3l2.2 6.8L21 12l-6.8 2.2L12 21l-2.2-6.8L3 12l6.8-2.2L12 3z" fill="#fff"/></svg>
          </div>
          <div class="brand-text">
            <h3>Talk to Trinka AI</h3>
          </div>
        </div>
        <div class="sheet-actions">
          <button class="icon-btn" (click)="minimize()" aria-label="Minimize">
            <svg viewBox="0 0 24 24" fill="none"><path d="M6 12h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
          <button class="icon-btn" (click)="endCall()" aria-label="Close">
            <svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
        </div>
      </div>
  
      <div class="orb-stage">
        <div class="orb">
          <div class="orb-glow"></div>
  
          <!-- idle: gentle breathing rings -->
          <div class="orb-idle-rings" *ngIf="state === 'idle'"><span></span><span></span><span></span></div>
  
          <!-- listening: real audio-reactive radial bars -->
          <div class="orb-wave" *ngIf="state === 'listening'">
            <i
              *ngFor="let level of audioBars; let i = index"
              [style.transform]="'translate(-50%,-80px) rotate(' + (360 / barCount) * i + 'deg)'"
              [style.height.px]="7 + level * 34"
            ></i>
          </div>
  
          <!-- thinking: rotating gradient ring (derived state, see component) -->
          <div class="orb-thinking-ring" *ngIf="state === 'thinking'"></div>
  
          <!-- speaking: ambient pulse -->
          <div class="orb-speaking-glow" *ngIf="state === 'speaking'"></div>
  
          <div class="orb-core">
            <svg class="mic-icon" *ngIf="state === 'idle' || state === 'listening'" viewBox="0 0 24 24" fill="none">
              <path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19 11a7 7 0 0 1-14 0M12 18v3" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
  
            <div class="think-dots" *ngIf="state === 'thinking'"><i></i><i></i><i></i></div>
  
            <div class="orb-eq" *ngIf="state === 'speaking'">
              <i *ngFor="let level of audioBars.slice(0,5)" [style.height.%]="30 + level * 70"></i>
            </div>
          </div>
        </div>
  
        <div class="status-text">
          <span class="status-dot"></span>
          <span>
            <ng-container [ngSwitch]="state">
              <ng-container *ngSwitchCase="'idle'">Tap the mic to start</ng-container>
              <ng-container *ngSwitchCase="'listening'">Listening…</ng-container>
              <ng-container *ngSwitchCase="'thinking'">Thinking…</ng-container>
              <ng-container *ngSwitchCase="'speaking'">Speaking…</ng-container>
            </ng-container>
          </span>
        </div>
  
        <div class="transcript">
          <span *ngIf="!latestLine" class="placeholder">
            Ask Trinka to fix grammar, rewrite a paragraph, or explain a suggestion — just say it.
          </span>
          <span *ngIf="latestLine" class="live-word">{{ latestLine.text }}</span>
        </div>
  
        <p class="error-text" *ngIf="errorMessage">{{ errorMessage }}</p>
      </div>
  
      <div class="sheet-controls">
        <button
          class="mute-btn"
          [class.active]="isMuted"
          (click)="toggleMute()"
          [attr.aria-label]="isMuted ? 'Unmute microphone' : 'Mute microphone'"
        >
          <svg viewBox="0 0 24 24" fill="none"><path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 11a7 7 0 0 1-14 0M12 18v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <button class="end-btn" (click)="endCall()" aria-label="End conversation">
          <svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
  
    </div>
  
  </ng-container>